import { collectPermissionActions, flattenPermissionActionsFromRoles, } from '@/shared/utils/user-api';
export function getAccountRoleNames(account) {
    return collectRoleNames(account.roles);
}
function collectRoleNames(value) {
    if (!Array.isArray(value))
        return [];
    return value
        .map((entry) => {
        if (typeof entry === 'string')
            return entry;
        if (entry && typeof entry === 'object' && 'name' in entry) {
            return String(entry.name);
        }
        return '';
    })
        .filter(Boolean);
}
/**
 * Maps user-management/api/account payload into Route guard session (roles + permissions like Monolithic private-route).
 */
export function normalizeAccountToSession(account) {
    const roles = getAccountRoleNames(account);
    const authorities = collectPermissionActions(account.authorities);
    const explicitPermissions = collectPermissionActions(account.permissions);
    const rolePermissionActions = flattenPermissionActionsFromRoles(account.roles);
    const effectiveRoles = roles;
    const username = typeof account.login === 'string'
        ? account.login
        : typeof account.email === 'string'
            ? account.email
            : '';
    const snapshot = {
        login: username,
        firstName: typeof account.firstName === 'string' ? account.firstName : undefined,
        lastName: typeof account.lastName === 'string' ? account.lastName : undefined,
        email: typeof account.email === 'string' ? account.email : undefined,
        langKey: typeof account.langKey === 'string' ? account.langKey : undefined,
        activated: typeof account.activated === 'boolean' ? account.activated : undefined,
    };
    /** Prefer explicit permissions; else flatten role grants; else legacy authorities list. */
    const permissions = explicitPermissions.length > 0
        ? explicitPermissions
        : rolePermissionActions.length > 0
            ? rolePermissionActions
            : [...authorities];
    return {
        username,
        roles: effectiveRoles,
        permissions,
        account: snapshot,
    };
}
